import Feature from 'ol/Feature';
// import Style from 'ol/style/Style';
// import Icon from 'ol/style/Icon';
import Point from 'ol/geom/Point';
import * as olProj from 'ol/proj';
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import { Circle, Fill, Stroke, Style} from 'ol/style';

export default class Coordinate{
    constructor(id){
        this.layer = new VectorLayer({
            id: id,
            opacity: 100,
            visible: true,
            source: new VectorSource(),
        });
    }

    setIconStyle(checkColor){
        var color;
        if(checkColor == 1){
            color = 'rgba(26, 98, 255, 1)';
        }else if(checkColor == 2){
            color = '#99CCFF';
        }else if(checkColor == 3){
            color = 'rgba(214, 39, 40)';
        }else if(checkColor == 4){
            color = '#FF9999';
        }

        var fill = new Fill({
            color: color,
        });
        var stroke = new Stroke({
            color: '#3399CC',
            width: 1.25
        });
        return new Style({
            image: new Circle({
                fill: fill,
                stroke: stroke,
                radius: 5
            }),
        });
    }

    setLayer(photos, opacity, zIndex){
        this.layer.getSource().clear();
        const lonLatIconFeatures = [];
        photos.forEach(element => {
            // let filtered = element['filtered'];
            // if (element['filtered'] === undefined || element['filtered'] === null){
            //     filtered = false;
            // }
            const marker = new Feature({
                geometry: new Point(olProj.fromLonLat([element['longitude'], element['latitude']])),
                name: element['filename'],
                // rotate: element['rotate'],
                // crop: element['crop'],
                // annotation_mark: element['annotation_mark'],
                // filtered: filtered
            });
            marker.setStyle(this.setIconStyle(opacity));
            lonLatIconFeatures.push(marker);
        })
        const vectorSource = new VectorSource({
            features: lonLatIconFeatures,
        });
        this.layer.setSource(vectorSource);
        this.layer.setZIndex(zIndex);

    }

    updateAnnotationMark(report){
        const features = this.layer.getSource().getFeatures();
        for (const image in report.annotation_image.list) {
            const index = features.findIndex((feature) => feature.get('name').split(/[\\/]/).pop().split('.')[0] === image);
            if (index >= 0){
                features[index].set('annotation_mark', report.annotation_image.list[image]['abnormality_shape_list']);
            }
        }
        this.layer.setSource(new VectorSource({
            features: features,
        }));
    }

    updateRotate(src, rotate, cropImages, annotations){
        const feature = this.layer.getSource().getFeatures().find(feature => feature.get('name') === src);
        if (feature){
            const crop = feature.get('crop');
            cropImages.forEach(item => {
                crop[item.custom_id] = {
                    rect: {width: item.width, height: item.height, top: item.top, left: item.left},
                    errorNote: item.errorNote,
                    errorType: item.errorType,
                    errorReason: item.errorReason
                };
            });
            const annotation_mark = feature.get('annotation_mark');
            annotations.forEach(item => {
                annotation_mark[item.custom_id] = item;
            });
            feature.set('rotate', rotate);
            feature.set('crop', crop);
            feature.set('annotation_mark', annotation_mark);
        }
    }

    updateCropImage(src, cropImage){
        const feature = this.layer.getSource().getFeatures().find(feature => feature.get('name') === src);
        if (feature){
            const crop = feature.get('crop');
            crop[cropImage.custom_id] = {rect: cropImage, errorNote: cropImage.errorNote, errorType: cropImage.errorType, errorReason: cropImage.errorReason};
            feature.set('crop', crop);
        }
    }
    //
    updateCropAbnormality(src, cropAbnormality){
        const feature = this.layer.getSource().getFeatures().find(feature => feature.get('name') === src);
        if (feature){
            const annotation_mark = feature.get('annotation_mark');
            annotation_mark[cropAbnormality.custom_id] = cropAbnormality;
            feature.set('annotation_mark', annotation_mark);
        }
    }

    deleteCropImage(src, cropImage){
        const feature = this.layer.getSource().getFeatures().find(feature => feature.get('name') === src);
        if (feature){
            const crop = feature.get('crop');
            delete crop[cropImage.custom_id];
            feature.set('crop', crop);
        }
    }

    deleteCropAbnormality(src, cropAbnormality){
        const feature = this.layer.getSource().getFeatures().find(feature => feature.get('name') === src);
        if (feature){
            const annotation_mark = feature.get('annotation_mark');
            delete annotation_mark[cropAbnormality.custom_id];
            feature.set('annotation_mark', annotation_mark);
        }
    }

    updateFilter(src, filtered){
        const feature = this.layer.getSource().getFeatures().find(feature => feature.get('name') === src);
        if (feature){
            feature.set('filtered', filtered);
        }
    }
}
